const NOTIFICATIONS = {
    data_copied_to_clipboard: 'Данные скопированы в буфер обмена',
    copy_to_clipboard_error: 'Ошибка копирования в буфер',
}

export {NOTIFICATIONS}